// import router from "@/router";
// import { MessageBox } from "element-ui";
// const isPortrait = screen.availHeight > screen.availWidth;
// const myWidth = isPortrait ? 600 : 800;
// const myHeight = isPortrait ? 800 : 600;
// console.log("screen.availHeight", screen.availHeight, screen.availWidth);
// console.log("isPortrait", isPortrait);
const state = {
  videoCallRTC: null, // RTC 本體
  RTCState: "",
  videoReady: false, // 是否正在進行 Video call
  muted: false, // 是否靜音(遠端 Video)
  remoteStream: null, // 遠端視訊串流
  localStream: null, // 本地視訊串流
  videoSender: null, // 分享中的視訊
  audioSender: null, // 分享中的音訊
  userInitVideoOptions: {
    audio: true,
    video: {
      frameRate: { ideal: 45, max: 60 },
      facingMode: {
        ideal: "environment",
      },
      enabled: true,
    },
  },
  videoOptions: {
    audio: true,
    video: {
      width: 1080,
      height: 720,
      // aspectRatio: 9 / 16,
      facingMode: "environment",
      enabled: true,
    },
  },
};

const actions = {
  // 進入視訊前的預覽畫面
  initUserMedia({ state, commit, dispatch }, payload = false) {
    let localVideo = document.querySelector("#preview-video");
    return new Promise((resolve, reject) => {
      navigator.mediaDevices
        .getUserMedia(state.userInitVideoOptions)
        .then((str) => {
          commit("setLocalStream", str);
          // dispatch("toggleAudio", payload); // 瀏覽器允許，但預設關閉
          // dispatch("toggleVideo", payload); // 瀏覽器允許，但預設關閉

          // const userDevice = rootState.global.customerSurvey.device;
          if (localVideo.srcObject !== str) {
            localVideo.srcObject = str;
          }
          localVideo.onloadedmetadata = function(e) {
            localVideo.play();
          };

          resolve("success");
        })
        .catch((err) => {
          if (!localVideo) {
            reject("Room not exsit.");
          } else {
            reject(err.message);
          }
        });
    });
  },
  // 關閉預覽的strem
  cleanLocalStream({ state, commit }) {
    // console.log("(2-1)關閉入口預覽 stream");
    if (state.localStream) {
      state.localStream.getTracks().forEach((track) => {
        track.stop();
      });
    }
    commit("setLocalStream", null);
  },
  toggleInitAudio({ state, commit }, payload) {
    let localAudioTrack = state.localStream.getAudioTracks()[0];
    localAudioTrack.enabled = payload;
    commit("toggleInitAudio", payload);
  },
  toggleInitVideo({ state, commit }, payload) {
    let localVideoTrack = state.localStream.getVideoTracks()[0];
    localVideoTrack.enabled = payload;
    commit("toggleInitVideo", payload);
  },
  toggleAudio({ state, commit }, payload) {
    let localAudioTrack = state.localStream.getAudioTracks()[0];
    localAudioTrack.enabled = payload;
    commit("toggleAudio", payload);
  },
  toggleVideo({ state, commit }, payload) {
    let localVideoTrack = state.localStream.getVideoTracks()[0];
    localVideoTrack.enabled = payload;
    commit("toggleVideo", payload);
  },
  // 正式進入videoCall的stream
  async initLocalStream({ state, commit, dispatch }) {
    // console.log("(3)正式初始化本地 Stream!");
    let stream = null;
    try {
      stream = await navigator.mediaDevices.getUserMedia(state.videoOptions);

      commit("setLocalStream", stream);
      dispatch("handlelocalVideo", stream);
      dispatch("initRTCPeerConnection");
    } catch (error) {
      console.log(`catch: [${error.code}] ${error.name} - ${error.message}`);
    }
  },
  handlelocalVideo({ state, dispatch }, stream) {
    // 控制本地 Video player
    let options = state.videoOptions;
    let localVideo = document.querySelector("#localVideo");

    if (localVideo.srcObject !== stream) {
      localVideo.srcObject = stream;
      let videoTrack = localVideo.srcObject.getVideoTracks()[0];
      let audioTrack = localVideo.srcObject.getAudioTracks()[0];
      videoTrack ? (videoTrack.enabled = options.video.enabled) : "";
      audioTrack ? (audioTrack.enabled = options.audio) : "";
    }
    // 調整回使用者預期的狀態
    dispatch("toggleAudio", state.userInitVideoOptions.audio);
    dispatch("toggleVideo", state.userInitVideoOptions.video.enabled);

    localVideo.onloadedmetadata = () => {
      // console.log("(6)本地 Stream 播放");
      localVideo.play();
    };
  },

  // webrtc
  async initRTCPeerConnection({ state, dispatch, commit }) {
    // console.log("(4)initRTCPeerConnection");
    const stream = state.localStream;
    const videoCallRTC = new RTCPeerConnection({
      // 配置ICE服務器
      iceServers: [
        { urls: "stun:stun.stunprotocol.org:3478" },
        { urls: "stun:stun.l.google.com:19302" },
        {
          urls: "turn:openrelay.metered.ca:443?transport=tcp",
          username: "openrelayproject",
          credential: "openrelayproject",
        },
      ],
    });

    stream.getTracks().forEach((track) => {
      // console.log(`[C]Client add local "${track.kind}" track.`);
      let sender = videoCallRTC.addTrack(track, stream);
      commit("setSender", { kind: track.kind, sender: sender });
    });

    // 建立 Offer 並送出
    const offer = await videoCallRTC.createOffer();
    const offerSignal = JSON.stringify({ sdp: offer });
    // console.log("(5)[Offer]建立/存下並送出！");
    videoCallRTC.setLocalDescription(offer);
    dispatch("videoCall/sendSignalToAgent", offerSignal, { root: true });

    // 創建應答連接
    videoCallRTC.onicecandidate = (e) => {
      if (e.candidate) {
        const signal = JSON.stringify({ candidate: e.candidate });
        dispatch("videoCall/sendSignalToAgent", signal, { root: true });
      } else {
        // Null candidate means we are done collecting candidates.
        dispatch("videoCall/sendSignalToAgent", null, { root: true });
        // console.log("(7)onicecandidate & sendSignalToAgent");
        // console.log("(8)本地 ICE 收集完畢!");
      }
    };

    videoCallRTC.oniceconnectionstatechange = (e) => {
      let { iceConnectionState } = e.target;
      console.log("[status] => ", iceConnectionState);
      commit("setRTCState", iceConnectionState);
      // if (iceConnectionState == "disconnected") {
      //   dispatch("hangup");
      // }
    };

    videoCallRTC.ontrack = (e) => {
      // console.log(`Get remote "${e.track.kind}" track!`);
      let remoteAudio = document.querySelector("#remoteAudio");
      if (remoteAudio && remoteAudio.srcObject !== e.streams[0]) {
        remoteAudio.srcObject = e.streams[0];
        remoteAudio.onloadedmetadata = function() {
          remoteAudio.play();
        };
        commit("setRemoteStream", e.streams[0]);
      }
    };

    commit("setVideoCallRTC", videoCallRTC);

    // dispatch("handlelocalVideo", state.stream);
  },
  async receiveSignal({ state, commit, dispatch }, payload) {
    const videoCallRTC = state.videoCallRTC;
    if (!videoCallRTC) {
      // console.log("videoCallRTC 未準備");
      return;
    }
    if (payload.signal) {
      // if (payload.signal == "hangup") {
      //   console.log("Agent關閉視訊");
      //   MessageBox.alert("偵測到專員暫時關閉視訊，請稍後。", "系統", {
      //     type: "info",
      //     center: true,
      //   });
      //   dispatch("hangup");
      //   // client也一起掛斷並跳出提示(Agent暫時關閉視訊!) 非結束 room
      //   // 避免 Agent 端重新進入收不到串流的 bug
      //   return;
      // }
      // const videoCallRoomId = payload.videoCallRoomId;
      const signal = JSON.parse(payload.signal);
      if (signal.sdp) {
        // console.log("[收到 SDP]setRemoteDescription");
        await videoCallRTC.setRemoteDescription(signal.sdp);
        const type = videoCallRTC.remoteDescription.type;
        // console.log("type:", type);
        if (type == "offer") {
          videoCallRTC.createAnswer().then(async (answer) => {
            await videoCallRTC.setLocalDescription(answer);
            // console.log("[Offer] 收到 Offer 回 Answer");
            dispatch(
              "videoCall/sendSignalToAgent",
              JSON.stringify({ sdp: answer }),
              { root: true }
            );
          });
        } else if (type == "answer") {
          //  console.log("[Answer] 收到 Answer！");
        }
      } else if (signal.candidate) {
        // console.log("[收到 ICE 候選位置]addIceCandidate");
        await videoCallRTC.addIceCandidate(signal.candidate);
      }
    } else {
      // console.log("對方收集 ICE 完畢");
      await videoCallRTC.addIceCandidate(null);
    }
  },
  cleanRTC({ state, commit }) {
    if (state.videoCallRTC) {
      state.videoCallRTC.close();
      commit("cleanVideoCallRTC");
    }
  },
  hangup({ state, commit }) {
    if (state.videoReady) {
      console.log("hangup");
      if (state.localStream) {
        state.localStream.getTracks().forEach((track) => {
          track.stop();
        });
      }
      let localVideo = document.querySelector("#localVideo");
      if (localVideo) {
        localVideo.srcObject = null;
      }

      state.videoCallRTC.close();
      commit("toggleVideo", false);
      commit("toggleAudio", false);
      commit("cleanVideoCallRTC");
    }
  },
  handleMuted({ commit }, payload) {
    let remoteAudio = document.querySelector("#remoteAudio");
    remoteAudio.muted = payload;
    commit("toggleMuted", payload);
  },
};

const mutations = {
  // webrtc
  setCanvas(state, { canvas, ctx }) {
    state.canvas = canvas;
    state.ctx = ctx;
  },
  setVideoOptions(state, payload) {
    state.videoOptions = payload;
  },
  toggleInitVideo(state, payload) {
    state.userInitVideoOptions.video.enabled = payload;
  },
  toggleInitAudio(state, payload) {
    state.userInitVideoOptions.audio = payload;
  },
  toggleVideo(state, payload) {
    state.videoOptions.video.enabled = payload;
  },
  toggleAudio(state, payload) {
    state.videoOptions.audio = payload;
  },
  setVideoCallRTC(state, payload) {
    state.videoCallRTC = payload;
    state.videoReady = true;
  },
  setLocalStream(state, payload) {
    state.localStream = payload;
  },
  setRemoteStream(state, payload) {
    state.remoteStream = payload;
  },
  setUserMediaStream(state, payload) {
    state.userMediaStream = payload;
  },
  setScreenShareStream(state, payload) {
    state.screenShareStream = payload;
  },
  setSender(state, payload) {
    let { kind, sender } = payload;
    if (kind == "video") {
      state.videoSender = sender;
    } else if (kind == "audio") {
      state.audioSender = sender;
    }
  },
  setRTCState(state, payload) {
    state.RTCState = payload;
  },
  cleanVideoCallRTC(state) {
    state.videoCallRTC = null;
    state.remoteStream = null;
    state.localStream = null;
    state.videoReady = false;
    state.videoSender = null;
    state.audioSender = null;
  },
  toggleMuted(state, payload) {
    state.muted = payload;
  },
};
const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
